import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ListImageContainer from './ListImageContainer';
import Container from '../Container';

const useStyles = makeStyles(theme => ({
    container: props => ({
        position: 'relative',
    }),
}));


export default (props) => {
    const classes = useStyles(props);
    return (
        <div className={classes.container}>
            {/* <div className={`bg`} /> */}
            <Container>
                {props.items && props.items.map((d, i) => {
                    return <ListImageContainer key={i} {...d} themeColor={props.theme.primary}/>
                })}
            </Container>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/cares/MainContent.js